import { render } from "./ConstantesModal.vue?vue&type=template&id=5dcd9d07&scoped=true"
import script from "./ConstantesModal.vue?vue&type=script&lang=js"
export * from "./ConstantesModal.vue?vue&type=script&lang=js"

import "./ConstantesModal.vue?vue&type=style&index=0&id=5dcd9d07&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dcd9d07"]])

export default __exports__